import { toNumber } from 'shared/lib/number/number';

import type { ReportWidgetItem } from 'widgets/ComposableReportWidget';

export type PropertyTableSortField = 'name' | 'spend';
export type PropertyTableSortDirection = 'asc' | 'desc';

export function getPropertyTableSpendColumnId(
    columnIds?: string[],
): 'spend' | 'totalSpend' {
    return columnIds?.includes('spend') && !columnIds.includes('totalSpend')
        ? 'spend'
        : 'totalSpend';
}

export function getPropertyTableSortField(
    columnId: string,
): PropertyTableSortField | null {
    if (columnId === 'property') {
        return 'name';
    }

    if (columnId === 'spend' || columnId === 'totalSpend') {
        return 'spend';
    }

    return null;
}

export function nextPropertyTableSort(args: {
    field: PropertyTableSortField;
    direction: PropertyTableSortDirection;
    columnId: string;
}): {
    field: PropertyTableSortField;
    direction: PropertyTableSortDirection;
} {
    const nextField = getPropertyTableSortField(args.columnId);

    if (!nextField) {
        return { field: args.field, direction: args.direction };
    }

    if (nextField === args.field) {
        return {
            field: args.field,
            direction: args.direction === 'asc' ? 'desc' : 'asc',
        };
    }

    return {
        field: nextField,
        direction: nextField === 'name' ? 'asc' : 'desc',
    };
}

export function sortPropertyWidgetItems(
    items: ReportWidgetItem[],
    field: PropertyTableSortField,
    direction: PropertyTableSortDirection,
): ReportWidgetItem[] {
    const dir = direction === 'asc' ? 1 : -1;

    return [...items].sort((a, b) => {
        if (field === 'name') {
            return (
                a.label.localeCompare(b.label, undefined, {
                    sensitivity: 'base',
                }) * dir
            );
        }

        return (toNumber(a.primaryValue) - toNumber(b.primaryValue)) * dir;
    });
}
